import parse from 'html-react-parser';
import ArrowDown from '@mui/icons-material/KeyboardArrowDown';
import ArrowUp from '@mui/icons-material/KeyboardArrowUp';
import React, { useContext, useState } from 'react';
import { AccordionContainer, AccordionContent, AccordionWrapper, Button } from './styles';
import { NotesContext } from '../../contexts/NotesContext';

interface IItem {
  title: string;
  content: string;
}

interface AccordionProps {
  highlighted?: boolean;
  data: IItem;
}

export default function Accordion({
  data,
  highlighted = false
}: AccordionProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { replace } = useContext(NotesContext);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <AccordionContainer $subject="" $isopen={isOpen}>
      <AccordionWrapper>
        <>
          <Button
            type="button"
            $textcolor={10}
            $subject="portuguese"
            $color={highlighted ? 40 : 50}
            $hovercolor={40}
            className={`accordion-button ${isOpen ? 'active' : ''}`}
            onClick={toggleAccordion}
            $isopen={isOpen}
            $highlighted={highlighted}
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                paddingRight: '3px'
              }}
          >
            { (parse(data.title, { replace })) }
            {isOpen ? <ArrowUp /> : <ArrowDown />}
          </Button>
          {isOpen && (
            <AccordionContent
              $textcolor={10}
              $subject="portuguese"
              $color={highlighted ? 40 : 50}
              $hovercolor={40}
            >
              { (parse(data.content, { replace }))}
            </AccordionContent>
           )}
        </>
      </AccordionWrapper>
    </AccordionContainer>
  );
}
